import { InlineIcon } from '@iconify/react';
import { FC, useCallback } from 'react';
import useConfirm from 'src/hooks/useConfirm';
import { SupplierInfo } from 'src/services/useInvoiceDetailsApi';
import SupplierInfoDialogContent from '../../../components/SupplierInfoDialogContent';

interface SupplierInfoProps {
  supplierInfo: SupplierInfo;
}

const SupplierInfoModal: FC<SupplierInfoProps> = ({ supplierInfo }) => {
  const { confirm } = useConfirm();

  const handleClick = useCallback(() => {
    confirm({
      title: 'Supplier Details',
      content: <SupplierInfoDialogContent supplierInfo={supplierInfo} />,
      cancelButtonText: 'Close',
      cancelColor: 'info',
      hasNoConfirmButton: true,
    });
  }, [confirm, supplierInfo]);

  const display = supplierInfo?.companyName ? supplierInfo?.companyName : supplierInfo?.name;

  return (
    <div title={display} className="p-1 text-[13px]">
      <div className="flex flex-row gap-1 items-center pb-1">
        <p className="font-bold"> Supplier </p>
        <span title={'View More'}>
          <InlineIcon
            icon="mdi:user-card-details-outline"
            onClick={handleClick}
            className="cursor-pointer"
          />
        </span>
      </div>
      <p>{display} </p>
    </div>
  );
};

export default SupplierInfoModal;
